import * as types from './types';
import { FILTER_FIELDS } from '../constants/filterFields';
import {
  extractSelectedNonHistoricalTicketForAllTab,
  getAllFilterParams,
  isSpecialist,
  getWhiteList,
  getPartnersAllowlist,
} from '../extractFromState';
import { chooseDefaultAllTicketId } from '../util';
import { showError } from '../util/errorPopupUtil';
import { serializeFiltersToUrl, mergeFilterParams } from '../util/filterUrlSerializer';
import { loadTicketIfExists, setLoading } from './index';
import { getAllTickets } from '../api/tickets';
import { ALL } from '../constants/tabNames';

export const changeSkipForAllFilter = (value) => ({
  type: types.SET_SKIP_FOR_ALL_FILTER,
  value,
});

export const changePaginationForAllFilter = (value) => ({
  type: types.SET_PAGINATION_FOR_ALL_FILTER,
  value,
});

export const resetPaginationForAllFilter = () => ({
  type: types.RESET_PAGINATION_FOR_ALL_FILTER,
});

export const setAllFilters = (payload) => ({
  type: types.SET_ALL_FILTERS,
  payload,
});

export const updateFilter = (field, value) => ({
  type: types.UPDATE_FILTER,
  field,
  value,
});

export const clearAllFilters = () => ({
  type: types.CLEAR_ALL_FILTERS,
});

export const changeTicketStatusForAllFilter = (ticketStatus) => updateFilter(FILTER_FIELDS.TICKET_STATUS, ticketStatus);

export const changeSortOrderForAllFilter = (sortOrder) => updateFilter(FILTER_FIELDS.SORT_ORDER, sortOrder);

export const changeDateRangeForAllFilter = (dateRange) =>
  updateFilter(FILTER_FIELDS.DATE_RANGE, {
    startDate: dateRange.startDate || null,
    endDate: dateRange.endDate || null,
    startTime: dateRange.startTime || null,
    endTime: dateRange.endTime || null,
  });

export const changeIdentifierForAllFilter = (type, value) => updateFilter(FILTER_FIELDS.IDENTIFIER, { type, value });

export const changePartialMatchForAllFilter = (partialMatch) => updateFilter(FILTER_FIELDS.PARTIAL_MATCH, partialMatch);

export const changeSelectedBusinessesForAllFilter = (businessIdList) =>
  updateFilter(FILTER_FIELDS.BUSINESS_IDS, businessIdList);

export const changeSelectedBusinessBrandOptionsForAllFilter = (selectedBrandOptions) =>
  updateFilter(FILTER_FIELDS.SELECTED_BRAND_OPTIONS, selectedBrandOptions);

export const changeExcludeBusinessesForAllFilter = (value) => updateFilter(FILTER_FIELDS.EXCLUDE_BUSINESSES, value);

export const setAllTabSearchPerformed = (hasSearched) => updateFilter(FILTER_FIELDS.HAS_SEARCHED, hasSearched);

export const syncAllFiltersToUrl = (history) => {
  return (_dispatch, getState) => {
    const state = getState();
    const filters = getAllFilterParams(state);
    const filterParams = serializeFiltersToUrl(filters);
    const location = history.location || window.location;
    const newSearch = mergeFilterParams(location.search, filterParams);
    if (newSearch !== location.search) {
      history.replace({ pathname: location.pathname, search: newSearch });
    }
  };
};

/** This is a simplified version of the old filterAllTickets
 * Whatever filter values are missing from params is defaulted to whatever is in state
 * @param  {Object} filterParams
 * @param {boolean} skipSelectingTicket
 * @returns {Function}
 */
export const filterAllTickets = (filterParams, skipSelectingTicket = false) => {
  return async (dispatch, getState) => {
    if (!filterParams || filterParams.skip == null) {
      dispatch(changeSkipForAllFilter(0));
    }

    if (!filterParams) {
      dispatch(resetPaginationForAllFilter());
    }

    const stateBeforeUpdate = getState();

    if (!isSpecialist(stateBeforeUpdate)) {
      return;
    }

    const paramsFromState = getAllFilterParams(stateBeforeUpdate);
    const combinedFilterParams = Object.assign({}, paramsFromState, filterParams);

    const {
      ticketStatus,
      businessIdList,
      brandOptions,
      excludeBusinesses,
      simplrTicketNumber,
      widgetId,
      roomId,
      platformTicketId,
      partialMatch,
      skip,
      dateRange,
      isPrev,
      cursor,
      sortOrder,
    } = combinedFilterParams;

    dispatch({ type: types.APPLY_SORT_ORDER, value: sortOrder || null });
    dispatch(setLoading(true, 'inbox'));

    const state = getState();
    const whiteList = getWhiteList(state);
    const partnersAllowlist = getPartnersAllowlist(state);

    try {
      const allTickets = await getAllTickets({
        ticketStatus,
        businessIdList,
        brandOptions,
        excludeBusinesses,
        skip,
        dateRange,
        simplrTicketNumber,
        widgetId,
        roomId,
        platformTicketId,
        partialMatch,
        whiteList,
        isPrev,
        cursor: cursor,
        partnersAllowlist,
        sortOrder,
      });

      dispatch({
        type: types.HYDRATE_ALL_TICKETS,
        tickets: allTickets,
      });

      dispatch(
        changePaginationForAllFilter({
          hasNextPage: allTickets.hasNextPage,
          hasPreviousPage: allTickets.hasPreviousPage,
          nextPageCursor: allTickets.nextPageCursor,
          previousPageCursor: allTickets.previousPageCursor,
        })
      );

      dispatch({
        type: types.START_ALL_TICKET_LQ,
      });

      const stateAfterUpdate = getState();

      const selectedTicketId =
        extractSelectedNonHistoricalTicketForAllTab(stateAfterUpdate) || chooseDefaultAllTicketId(stateAfterUpdate);

      if (!skipSelectingTicket && selectedTicketId) {
        // selects ticket and loads conversation
        dispatch(loadTicketIfExists(selectedTicketId, ALL));
      } else if (!selectedTicketId) {
        dispatch({ type: types.CLEAR_ALL_TICKET });
      }
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setLoading(false));
      showError(e);
    }
  };
};
